import axios from 'axios'

const instance = axios.create({
  headers: {
    /* eslint-disable-next-line no-undef */
    'x-lls-agent': 'Lelivrescolaire/frontend-ressources (web;)'
  }
})
export default instance
